var React = require('react');

function ElectricityComponent (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4.86523 10.1566C4.86523 10.0891 4.87982 10.0213 4.90933 9.95785L8.81859 1.55477C8.89783 1.38482 9.07144 1.27539 9.26221 1.27539H14.6608C14.8434 1.27539 15.0101 1.3748 15.0942 1.53353C15.1308 1.60288 15.1489 1.67843 15.1489 1.75373C15.1489 1.85077 15.1188 1.94738 15.0595 2.02976L11.1343 7.48591H13.9161C14.1061 7.48591 14.2789 7.59413 14.3589 7.76369C14.4386 7.93244 14.4112 8.13165 14.2887 8.27355L6.09763 17.7725C6.00245 17.8835 5.86438 17.9421 5.72509 17.9421C5.64257 17.9421 5.55883 17.922 5.48326 17.8787C5.27861 17.7641 5.1871 17.5232 5.26472 17.3055L7.64418 10.6349H5.35295C5.1871 10.6349 5.03269 10.5523 4.94283 10.4152C4.89138 10.337 4.86524 10.247 4.86523 10.1566ZM9.57594 2.23218L6.11194 9.67847H8.33127C8.48976 9.67847 8.63804 9.75303 8.72914 9.87969C8.82064 10.0064 8.84433 10.1687 8.79204 10.3146L7.05718 15.1779L12.8647 8.4431H10.1932C10.011 8.4431 9.84391 8.34369 9.76017 8.18496C9.67602 8.02623 9.68991 7.83463 9.79448 7.68833L13.7197 2.23218H9.57594Z","fill":"#3E3E3E"}));
}

ElectricityComponent.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = ElectricityComponent;

ElectricityComponent.default = ElectricityComponent;



//////////////////
// WEBPACK FOOTER
// ./src/containers/ProfileV2/images/electricity.component.svg
// module id = 1666
// module chunks = 0